import React, { useEffect, useState } from "react";
import CircularProgress from "@material-ui/core/CircularProgress";
import { makeStyles } from "@material-ui/core/styles";
import { useParams } from "react-router-dom";
import PhoneNumberTable from "./PhoneNumberTable";
import { fetchWithToken } from "../../../../apiUtils";

const useStyles = makeStyles({
  table: {
    marginTop: 45,
  },
  loading: {
    marginTop: "25%",
    marginLeft: "50%",
  },
});

const PhoneNumbersByRange = () => {
  const classes = useStyles();
  const { rangeId } = useParams();

  const [dataObj, setDataObj] = useState({
    phoneNumbers: [],
    loading: true,
  });

  useEffect(() => {
    fetchWithToken(`api/PhoneNumbers/ByRange/${rangeId}`)
      .then((response) => response.json())
      .then((data) =>
        setDataObj({
          phoneNumbers: data,
          loading: false,
        })
      );
  }, []);

  return (
    <>
      {dataObj.loading ? (
        <CircularProgress className={classes.loading} />
      ) : (
        <div className={classes.table}>
          <PhoneNumberTable data={dataObj.phoneNumbers} />
        </div>
      )}
    </>
  );
};

export default PhoneNumbersByRange;
